module.exports = __webpack_public_path__ + "img/05.330951e0.jpg";